export default class Footer {
  constructor(element) {
    this.element = element;
    this.yearElements = this.element.querySelectorAll('[data-footer-year]');
    this.language = this.element.querySelector('[data-footer-language]');

    this.init();
  }

  init() {
    this.setCurrentYear();
    this.initLanguageMenu();
  }

  setCurrentYear() {
    const currentYear = new Date().getFullYear().toString();

    for (let i = 0; i < this.yearElements.length; i++) {
      this.yearElements[i].textContent = currentYear;
    }
  }

  // Menu de langues qui s'ouvre vers le haut au clic
  initLanguageMenu() {
    if (!this.language) return;

    const toggle = this.language.querySelector('.footer__language-toggle');

    const setOpen = (isOpen) => {
      this.language.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    toggle.addEventListener('click', () => {
      setOpen(!this.language.classList.contains('is-open'));
    });

    document.addEventListener('click', (event) => {
      if (!this.language.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.language.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  }
}
